import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import uuid from 'react-uuid';
import { useDispatch } from 'react-redux';
import { addPageSpinner, removePageSpinner } from '../../Store/Actions/spinner';

export default function PayingCustomerAgreement() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const spinnerId = uuid();
    setPageSpinner(spinnerId);
    setTimeout(() => {
      extractPageSpinner(spinnerId)
    }, 1000);
  }, []);

  const scrollToCurrentPosition = (activeSection) => {
    const currentSection = document.getElementById(activeSection);

    if (currentSection) {
      window.scrollTo({
        top: currentSection.getBoundingClientRect().top + document.documentElement.scrollTop - 200,
        behavior: "smooth"
      });
      currentSection.classList.add("active-section");
      setTimeout(() => {
        currentSection.classList.remove("active-section");
      }, 5000);
    }
  };

  const setPageSpinner = useCallback(spinner => {
    dispatch(addPageSpinner(spinner));
  }, []);

  const extractPageSpinner = useCallback(spinner => {
    dispatch(removePageSpinner(spinner));
  }, []);


  return (
    <section className="cx--section mt-5">
      <div className="container">
        <div className='row'>
          <div className="cx--contact-info-wrapper">
            <strong className="cx--section-title-sm">Paying Customer Cryllex Terms of Use/Agreement</strong>
            <small className="d-block cx--contact-info-text mt-3"><span className='cursor-pointer text-underline' onClick={() => navigate("/")}>Home</span> / Cryllex Global Limited</small>
            <small className="d-block cx--contact-info-text">Cryllex Inc.</small>
            <small className="d-block cx--contact-info-text">Last Updated: April 19, 2025</small>
            <small className="d-block cx--contact-info-text">Official Cryllex Document:</small>
          </div>

          <div className="cx--contact-info-wrapper mt-5">
            <strong className="cx--section-title-lg">TABLE OF CONTENTS</strong>
            <ul className='mt-2'>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_1")}><Link to="#">Introduction</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_2")}><Link to="#">Scope of Services</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_3")}><Link to="#">Making a Payment</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_4")}><Link to="#">User Registration</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_5")}><Link to="#">Cryllex ID Management</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_6")}><Link to="#">Information Usage</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_7")}><Link to="#">Supported Virtual Assets</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_8")}><Link to="#">Unsupported Payments</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_9")}><Link to="#">Transaction Fees</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_10")}><Link to="#">Payment Exceptions: Underpayments, Overpayments, Orphan Payments</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_11")}><Link to="#">Additional Payment Review</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_12")}><Link to="#">Wallet Security</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_13")}><Link to="#">Disclaimers</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_14")}><Link to="#">Limitation of Liability</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_15")}><Link to="#">Governing Law, Arbitration and Class Action Waiver</Link></li>
              <li className='cursor-pointer' onClick={() => scrollToCurrentPosition("block_16")}><Link to="#">Modification to the Agreement</Link></li>

            </ul>
          </div>



          <div id="block_1" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(0) Introduction</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                This Paying Customer Agreement (the "Agreement", "Terms") sets forth the respective rights and
                obligations between you and Cryllex Global Limited, a corporation formed under the laws of the British
                Virgin Islands ("Cryllex"). The term “Cryllex” will be used in this Agreement to refer to the Cryllex
                entity with which you will engage in a contractual relationship. As used herein, "you" and “your” refers to
                the individual or liable entity agreeing to the terms of this Agreement either in writing or via electronic
                acceptance; references to "we," "us," and "our" refer to Cryllex Global Limited.
              </span>
              <span className='d-block my-3'>
                This Agreement governs your use of the Cryllex Software Services, either directly or through the use of
                an authorized third-party, which you are using to make a payment to a Merchant ("Services"). By making
                a payment using the Services, you agree to be bound by the terms and conditions of this Agreement,
                including the arbitration clause and class action waiver.
              </span>
              <span className='d-block my-3'>
                By registering a Cryllex ID, accessing or using the Services, you agree to be legally bound by the terms
                and conditions of this Agreement in their entirety, including any terms incorporated by reference. Please
                read it carefully.
              </span>
              <span className='d-block my-3'>
                Nothing in these Terms should be construed as creating a partnership or joint venture of any kind between
                the parties and neither party will have the authority to bind the other party or to contract in the name of or
                create a liability against the other party in any way or for any purpose.
              </span>
              <span className='d-block my-3'>
                If you do not agree to any of these terms and conditions, including the mandatory arbitration provision,
                DO NOT register a Cryllex ID or access or use the Services.
              </span>
            </div>
          </div>
          <div id="block_2" className="cx--contact-info-wrapper mt-4">
            <div>
              <strong className="cx--section-title-lg d-block">(1.0) Scope of Services</strong>
              <strong className="cx--section-title-lg d-block mt-2">(1.1) Our Services</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  The Services may be made available to you via a third-party desktop, mobile, web application, the
                  Cryllex web portal or API.
                </span>
                <div className='my-3'>
                  You must not use or access the Services (including, but not limited to):
                  <ol>
                    <li>
                      In any way that is misleading or deceptive, infringes upon another person's rights (including
                      Intellectual Property Rights or Privacy Rights);
                    </li>
                    <li>
                      To copy, scrape or store any Content;
                    </li>
                    <li>
                      To modify or reverse engineer the API; or
                    </li>
                    <li>
                      Re-supply, re-sell, sub-license to any other person or alter any part of the Content except as
                      explicitly provided for in this Agreement.
                    </li>
                  </ol>
                </div>
                <span className='d-block my-3'>
                  You acknowledge that Cryllex may monitor API activity from its own systems for the purpose of
                  ensuring quality, improving the Cryllex Service, products and API, and ensuring compliance with these
                  Terms.
                </span>
                <span className='d-block my-3'>
                  The Services enable participating merchants or other businesses ("Merchant") to conveniently receive
                  virtual assets payments (also known as "digital assets," "virtual currency," "cryptocurrency" and "digital
                  currency") from you, the "Paying Customer" or "Payer" as payment for goods or services in any of the
                  Supported Virtual Assets (defined below). The Services are only compatible with those merchants and
                  businesses that accept virtual asset payments using Cryllex's services, either directly or through a thirdparty agent.
                </span>
                <span className='d-block my-3'>
                  By using our Service, you acknowledge that Cryllex is not a Virtual Asset Service Provider as it is a
                  software solution for Merchants to accept payments for their goods or services with Virtual Assets.
                </span>
                <span className='d-block my-3'>
                  Cryllex Global Limited is an amalgam of software services designed for the convenience of seamless
                  utilization of blockchain technologies. All transactions that fall within the scope of our Services are
                  public, with "on-chain" data or through regulated fiat channels. Cryllex does not exclude the possibility of
                  supporting or participating in economic and trade sanctions programs administered by the United Nations,
                  the Office of Foreign Assets Control (OFAC) of the United States Department of the Treasury, the USA
                  PATRIOT Act, and other anti-money laundering (AML) and anti-terrorist financing (ATF) laws.
                </span>
                <span className='d-block my-3'>
                  As required by applicable laws and regulations, Cryllex Global Limited maintains a comprehensive
                  AML/ATF/Sanctions compliance program integrated within the software for Merchants and third-party
                  licensed payment service providers including "Agents" (also known as "Money Service Providers",
                  "Payment Service Providers" or generally any company or organization licensed or regulated to process
                  payments either in Virtual Assets or Fiat currencies).
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(1.1.1) Transactions, Settlement and Custody </strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  You understand and acknowledge that while Cryllex may provide the necessary technology infrastructure
                  to simplify the use of decentralized blockchain infrastructure for Merchants (through non-custodial
                  integrations to blockchain infrastructure via APIs, automated instructions, transactional instructions, and
                  transaction record keeping), Cryllex does not at any point process or take custody of any virtual asset or
                  fiat currency, on your behalf, within the scope of our Services. Furthermore, you understand and
                  acknowledge that all virtual assets and fiat currencies are transacted and settled by Agent(s) available to
                  the Merchant.
                </span>
                <span className='d-block my-3'>
                  You acknowledge and understand that Cryllex is not a party to the contract between you and the
                  Merchant. Cryllex acts as a software that facilitates the use of blockchain networks and is not a party to
                  any agreement to buy, sell or provide goods or services.
                </span>
                <span className='d-block my-3'>
                  Other than the specific obligations expressly set out in these Terms, Cryllex is not responsible or liable to
                  you for any failure by a Payer or Merchant to comply with these Terms or any other legal obligations, or
                  for any obligations that you and/or the Payer are required to perform.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(1.1.2) Cost Calculation Engine</strong>
              <div className="cx--contact-info-text mt-2">
                <div>
                  <span>
                    To ensure that the correct price is represented for the goods and services being sold by the Merchant,
                    Cryllex services includes a Cost Calculation Engine, acting in good faith and in a commercially
                    reasonable manner to make determinations related to any price adjustments, obligations, disruptions,
                    valuations, exchange rates, and settlements that occur throughout the duration of a transaction involving
                    virtual assets and fiat currencies. When you or the Merchant are using our Services to transact, Cryllex
                    shall calculate the transaction costs for the Merchant using the following information:
                  </span>
                  <ol>
                    <li>
                      Blockchain related fees, including on-chain blockchain transaction fee approximations and onchain bridging fee approximations, sampled from the prevailing fees indicated on public portals
                      prior to the transaction execution;
                    </li>
                    <li>
                      Virtual asset off-ramp (virtual asset to fiat) conversion fees provided by participating exchanges,
                      liquidity provider(s) and/or Agents designated by the Merchant;
                    </li>
                    <li>
                      Fiat settlement fees, including, but not limited to, telegraphic transfer costs, global transaction
                      fees, SWIFT fees, local banking fees and/or foreign exchange conversion fees by Agents.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(1.1.3) Tax Reporting</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  You understand and agree that Cryllex is not required to provide any tax forms or reports related to your
                  activity on or through Cryllex. You are solely responsible for any taxation obligations.
                </span>
                <span className='d-block my-3'>
                  Cryllex reserves the right to give you the option to receive proof of transactions, including merchant
                  receipts, generated by our Services and transaction records, or reports, related to your Cryllex
                  transactions. The type of document you receive may depend on the jurisdiction in which you are located.
                </span>
                <span className='d-block my-3'>
                  You will not hold Cryllex liable or responsible for any information provided to you on any document you
                  receive from Cryllex. You further understand that you are ultimately and solely responsible for
                  determining, reporting, and paying any tax liability incurred by your activity within the scope of our
                  Services.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(1.1.4) Cryllex ID</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  During the payment verification process (See Section 3) you as the Payer will receive a Cryllex Paying
                  Customer ID, unique to your name and mobile phone number provided at the transaction Checkout
                  Window. A Cryllex ID is a system-generated identification number used to maintain a record of the
                  transactions to a Merchant. It is automatically generated and tied to all entities involved in usage of the
                  Services (Paying Customer, Merchants, Agents), along with other personal information and
                  documentation gathered during the confirmation processes required for accessing the Services. The usage
                  of “Cryllex ID” throughout this document is a broad reference to the Cryllex ID assigned to each entity
                  involved in any transaction via Cryllex – the Paying Customer, Merchant and Agent.
                </span>
              </div>
            </div>
            <div className="mt-3">
              <strong className="cx--section-title-lg d-block">(1.2) Eligibility</strong>
              <strong className="cx--section-title-lg d-block mt-2">(1.2.1) Entities</strong>
              <div className="cx--contact-info-text mt-2">
                <div>
                  <span>
                    To use the Services, you must be an entity duly formed and legally authorized to operate in the
                    jurisdiction of your formation ("Entity"). If you are registering or using the Services on behalf of a legal
                    entity, you represent and warrant that:
                  </span>
                  <ol>
                    <li>
                      Said legal entity is duly organized and validly existing under the Applicable Laws of its
                      jurisdiction; and
                    </li>
                    <li>
                      You are duly authorized by said legal entity to act on its behalf.
                    </li>
                  </ol>
                </div>
                <div>
                  <span>
                    You further represent and warrant that you:
                  </span>
                  <ol>
                    <li>
                      Have not previously been suspended or removed from using the Services; and
                    </li>
                    <li>
                      Have all powers and authority necessary to enter into this Agreement and in doing so will not
                      violate any other agreements to which you are a party.
                    </li>
                  </ol>
                </div>
                <span className='d-block my-3'>
                  Cryllex is not responsible or liable for relying on the representations of your agents, employees,
                  contractors, attorneys, financial advisors, or any other person Cryllex reasonably believes represents you
                  in the acceptance of this Agreement or in the acceptance of any other instruction provided through the
                  Services offered.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(1.2.2) Services and Your Location</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  By using the Services, you are establishing a contractual relationship with Cryllex Global Limited (a BVI
                  company). You understand and agree that the Services made available to you may be limited depending
                  on the Jurisdiction you are accessing the Services from, and Cryllex reserves the right to restrict the
                  Services made available to you based on the credibility of your wallet and location, determined through
                  your mobile number or your IP address. You further understand and agree that the Services may be
                  limited or terminated if you are located in or move to a jurisdiction that is not supported by Cryllex.
                  Cryllex shall not be liable to you for any claims related to the limitation or termination of the Services
                  based on your location. You shall hold Cryllex harmless for any actions taken by Cryllex resulting from
                  your moving to a new jurisdiction or accessing the Services from an unsupported jurisdiction.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg d-block mt-2">(1.2.3) Restricted Jurisdictions</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  You may not register to use the Services if you are located or organized in, under the control of, or
                  resident of any state, country, territory, or other jurisdiction to which the United Nations has sanctioned or
                  embargoed goods or services, or where your use of the Services would be illegal or otherwise violate any
                  applicable law of such jurisdiction or of the United Nations ("Restricted Jurisdiction"). We may
                  implement controls to restrict access to the Services from any Restricted Jurisdiction. You hereby
                  represent and warrant that you are not under the control of, or resident of, any Restricted Jurisdiction and
                  that you will not access or use any Services while located in any Restricted Jurisdiction, even if the
                  safeguards to our Services from these jurisdictions are proven ineffective.
                </span>
              </div>
            </div>
          </div>
          <div id="block_3" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(2.0) Making a Payment</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                When you choose to make a payment using the Services, you will be redirected to the Cryllex Checkout
                Window where you will have the option to make selections that are necessary to execute the transaction.
                Whether you are making payment via Instant Payments or ECommerce Checkout, you will be redirected
                to the same payment window.
              </span>

              <span className='d-block my-3'>
                At the Checkout Window, you will be presented with the Merchant Invoice Price, the commission
                charged, and the total amount to be paid, among some other transaction-specific information.
              </span>
              <span className='d-block my-3'>
                Payments must be completed within the Payment Period, guided by the timer on the Checkout Window,
                or the invoice will expire. Payments made to expired invoices cannot complete an invoice or purchase,
                deemed Orphan Payments (defined below). Do not send a payment to an expired invoice. You agree not
                to hold Cryllex liable or responsible for any payment lost to any form of an expired invoice.
              </span>
              <span className='d-block my-3'>
                If an invoice expires, you must generate a new invoice by restarting the checkout process. The new
                invoice will provide a new Payment Period and an updated payment amount based on any new alterations
                detected by our Cost Calculation Engine since your prior, expired, invoice.
              </span>
            </div>

            <div>
              <strong className="cx--section-title-lg">(2.1) Prohibited Activities</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  When accessing and using the Services, you must not (non-exhaustive):
                </span>
                <ol>
                  <li>Provide incorrect, incomplete or inaccurate information;</li>
                  <li>Make any payments that are inconsistent with your legal and lawful intent;</li>
                  <li>Impersonate another person or misrepresent authorization to act on behalf of others;</li>
                  <li>Misuse the Services in any way which may impair the functionality of the underlying systems or
                    impair the ability of any other to use the Services; and</li>
                  <li>
                    Attempt to view, access or copy any material or data other than that which you are authorized to
                    access.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div id="block_4" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg d-block">(3.0) User Registration</strong>
            <strong className="cx--section-title-lg d-block mt-2">(3.1) Information Required to Access Services </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Information that we collect from you will be detailed to you upon accessing the Services. Cryllex may, in
                its sole discretion, dictate the exact information required or ask for more information before allowing you
                to proceed with accessing the Services.

              </span>
            </div>

            <div>
              <strong className="cx--section-title-lg d-block mt-2">(3.1.1) Personal Information</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  For individuals, before accessing the Services, you must provide Cryllex with information and
                  documentation that is requested for the purpose of establishing and verifying your identity ("Personal
                  Information"). Personal Information includes, but is not limited to, your name, email address and phone
                  number. Personal Information may also include documentation, such as copies of your government-issued
                  photo identification (for example, your passport, driver's license, or military identification card), to
                  confirm your identity and eligibility to use the Services.
                </span>
                <span className='d-block my-3'>
                  Personal Information will be retained by us at our discretion and may be made available to any law
                  enforcement, government, authority or regulator upon reasonable request in accordance with applicable
                  laws and regulations. You agree to provide accurate, current, and complete Personal Information.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(3.1.1.1) Personal Information Required for Transactions</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  In paying an invoice or within an e-commerce platform, you understand and agree that you will be
                  required to provide Cryllex with your email address and/or SMS compatible phone number. Some
                  Merchants may require Cryllex to collect your name and physical address during the payment process to
                  fulfill certain legal and compliance obligations. Your email address and/or SMS compatible phone
                  number will be used for certain payment and/or refund communications and therefore must be your valid
                  email address and/or SMS compatible phone number.
                </span>
                <span className='d-block my-3'>
                  Cryllex will additionally automatically collect information including, but not limited to, wallet history, IP
                  address, geographic location, item being purchased, and transaction amount. Cryllex collects this
                  information subject to its Privacy Notice, published on our website.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(3.1.1.2) Personal Information Required for Transactions Exceeding a Specified Threshold</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  Merchants and Agents are required by local laws and regulations to collect certain information about you
                  for transactions and refunds over a certain size and, in some regions, for any transaction. Our systems
                  integrate this function on behalf of Merchants and Agents. You understand and agree that you may be
                  required to undergo an additional verification process conducted through a third-party identity verification
                  provider. Furthermore, you understand that in doing so, you will be subject to a separate set of terms
                  made available to you by that third-party identity verification provider. For simplicity, any information
                  we require as outlined in Sections 3.1.1 and 3.1.2 will be referred to as "Background Information."
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg d-block mt-2">(3.1.1.3) Threshold Determination</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  This transaction threshold is a system setting determined and adjusted to the lower value required by a
                  given Merchant and their respective Agents. Cryllex also reserves the right to make appropriate
                  adjustments to the transaction threshold level.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg d-block mt-2">(3.1.2) Entity Information</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  During the Cryllex ID registration process for entities, you must provide Cryllex with information and
                  documentation that is requested for the purpose of establishing and verifying your entity information
                  ("Entity Information"). Entity Information may include, but is not limited to, the name, email address,
                  phone number, date of birth, and taxation identification number of each of the ultimate beneficial owners,
                  controlling persons or directors ("UBO"), in addition to the entities corporate tax identification number
                  and incorporation documents, certificate of incumbency, certificate of good standing, or other corporate
                  information and documentation as applicable and requested by Cryllex on behalf of the Merchant or the
                  Merchant's preferred Agent. Entity Information will be retained by Cryllex on behalf of the Merchant and
                  Agent for a minimum statutory period of seven (7) years and may be made available to any law
                  enforcement, government body, authority or regulator upon reasonable request in accordance with
                  applicable laws and regulations. You agree to provide accurate, current, and complete Entity Information.
                  Herein, Personal Information and Entity Information shall collectively be referred to as "Background
                  Information."
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg d-block mt-2">(3.2) Verification</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  You hereby authorize Cryllex, or a third-party service provider that we designate, to take any measures
                  we consider necessary to maintain continual confirmation of the Background Information you provide,
                  verify and authenticate your Background Information, and take any action deemed necessary based on the
                  results on behalf of Merchants and Agents. You acknowledge that this process may result in a delay in
                  accessing our Services, and that you will not be authorized to do so until your Cryllex ID registration has
                  been successfully completed.
                </span>
              </div>
            </div>
          </div>
          <div id="block_5" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg d-block">(4.0) Cryllex ID Management</strong>
            <strong className="cx--section-title-lg d-block mt-2">(4.1) Cryllex ID Maintenance</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                You are solely responsible for keeping the information associated with your Cryllex ID updated at all
                times. In the case that information and documentation previously provided by you, as an individual or an
                entity, has expired or has changed, you shall be required to make the necessary amendments in a timely
                manner or go through the registration process again. You understand that a change in the geographical
                location of residence may impact your eligibility to access and use the Services.
              </span>
              <span className='d-block my-3'>
                As part of our legal compliance service ("AML Program") offered to Merchants and Agents, we will
                monitor your Cryllex ID and your use of the Services and review your Background Information and any
                transaction related activity on an ongoing basis, as may be required by law and/or pursuant to a
                Merchant's or Agent's internal policies and procedures. We may, at any time, require you to provide us
                with additional Background Information, or any other information reasonably requested, as a condition to
                your continued access to and use of the Services. During such a time, your access to and use of the
                Services may be temporarily restricted until they satisfy the minimum requirements of the Merchant or
                Agent, whichever of the two is higher.
              </span>
            </div>

            <div>
              <strong className="cx--section-title-lg">(4.2) Potentially Fraudulent Activity</strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  Cryllex designs digital Anti-Money Laundering and Counter-Terrorist Financing policies on behalf of
                  your Merchant and their designated Agent. These policies are designed to detect and prevent fraud or to
                  identify and assess fraud-related risk. Cryllex shall monitor your use of the Services in accordance with
                  the minimum risk parameters and thresholds established by Merchants or Agents, whichever of the two is
                  higher. In the event of detection of fraudulent or suspicious activity, Cryllex systems are designed to
                  restrict access to the Services, and further, is required to submit notice to the respective Merchant and/or
                  Agent. Should the standard operating procedures be pre-defined and automated within the Cryllex system,
                  the Merchant or Agent may have automated alerts established to the relevant authorities.
                </span>
                <div className='my-3'>
                  <span>In the event of an investigation, you agree to:</span>
                  <ol>
                    <li>
                      Fully cooperate with the Merchant or Agent in such an investigation, with certain communication
                      and evidence gathering being done through Cryllex;
                    </li>
                    <li>
                      Complete any required affidavits promptly, accurately and thoroughly;
                    </li>
                  </ol>
                </div>
                <span className='d-block my-3'>
                  You understand and acknowledge that any failure to cooperate in any such investigation may cause delays
                  in regaining access to the Services.
                </span>
              </div>
            </div>
          </div>
          <div id="block_6" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg d-block">(5.0) Information Usage</strong>
            <strong className="cx--section-title-lg d-block mt-2">(5.1) Internal Information Use </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Background Information will be encrypted and stored on secure servers, and is only accessible by Agents,
                Merchants, and in the case of any suspected fraudulent activity, local authorities, law enforcement or
                regulators of the respective jurisdictions that the transaction has taken place in. At any time, you will have
                the ability to login to your Paying Customer Portal to view the transaction history associated with your
                Cryllex ID. From the portal, you may also choose to delete items from your transaction history; the
                individual transaction item will be removed as a visible line item only from your account. Cryllex
                maintains transaction records on behalf of Merchants and Agents for the minimum statutory period of
                seven (7) years.
              </span>
            </div>
            <div>
              <strong className="cx--section-title-lg d-block mt-2">(5.2) Authorization to Share Background Information </strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  Accessing our Services is an authorization by you, the Merchant and their designated Agent, and/or an
                  applicable third-party, to access any of your Background Information, and to continue holding such
                  information, including any revisions or additions thereto, with the Merchant, Agent and/or the applicable
                  third-party, on an ongoing basis.
                </span>
                <span className='d-block my-3'>
                  You understand that on behalf of the Merchant or their designated Agent, we may retain all user
                  information, including activity related to the Services and Background Information, as required by this
                  Agreement and local laws or regulations, and may share such information with a given jurisdiction's
                  government agency, law enforcement, regulator or other third-party in order to verify the Background
                  Information in accordance with Section 3 above.
                </span>
                <span className='d-block my-3'>
                  For further information on how we use or share your Background Information and other information you
                  provide us during the use of the Services, refer to the Cryllex Privacy Policy.
                </span>
              </div>
            </div>
            <div>
              <strong className="cx--section-title-lg">(5.3) Authorization to Share Transaction Information with Agent </strong>
              <div className="cx--contact-info-text mt-2">
                <span>
                  If you are accessing our Services, you hereby authorize the Merchant to provide the Agent with
                  information relating to your transaction, including but not limited to the transaction value, and
                  Background Information.
                </span>
              </div>
            </div>
          </div>
          <div id="block_7" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(6.0) Supported Virtual Assets</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Software within the Services portfolio is designed to support several different virtual asset blockchain
                protocols ("Supported Virtual Assets"). The Merchant may choose to accept payments in all or a subset of
                the Supported Virtual Assets, and the Merchant is solely responsible for indicating which virtual assets
                they choose to accept for payment. Cryllex may, at its discretion, add or remove support for digital
                currencies from time-to-time as a technological support feature. Supported Virtual Assets are indicated
                through the selection available on the Cryllex Service and are updated on a regular basis.
              </span>
            </div>
          </div>
          <div id="block_8" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(7.0) Unsupported Payments</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Payments made using any virtual asset, token, coin or cryptocurrency other than the ones that Cryllex has
                listed as a Supported Cryptocurrency are "Unsupported Payments". Unsupported Payments cannot be
                applied to a Merchant invoice or e-commerce platform. You agree and understand that any Unsupported
                Payments sent to a temporary Merchant wallet may not be received, and Cryllex will be unable to
                facilitate access or recover such Unsupported Payments on behalf of the Merchant.
              </span>
              <span className='d-block my-3'>
                You agree to use only supported currencies to pay invoices or e-commerce portals. You are solely
                responsible for losses caused by any Unsupported Payments and acknowledge that Unsupported
                Payments may be lost and unable to be recovered or refunded. Cryllex also reserves the right to
                temporarily suspend refund processing of Unsupported Payments and/or other payments made using the
                Services. Cryllex, the Merchant or their designated Agent will not be held responsible or liable for any
                Unsupported Payment.
              </span>
            </div>
          </div>
          <div id="block_9" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(8.0) Transaction Fees</strong>
            <div className="cx--contact-info-text mt-2">
              <div>

                <span>
                  You will incur certain fees in connection with making cryptocurrency payments when using the Payment
                  Services. You will incur blockchain transaction fees such as gas fees and network costs as set forth in this
                  Section. You will also incur Refund Fees on refunds, as set forth in Sections 7 and 9. You may also incur
                  Cryllex's infrastructure utilization fees if the Merchant chooses to pass the fee through to you, as set forth
                  in this Section:
                </span>
                <ol>
                  <li>
                    For blockchain protocols, transaction processing fees sometimes referred to as Gas Fees
                    ("Network Fees") are fees required to broadcast on-chain cryptocurrency transactions to the
                    relevant blockchain stakeholders, such that it will prioritize and process the transactions and
                    maintain the integrity of the blockchain protocol. Network Fees are paid to certain blockchain
                    stakeholders.
                  </li>
                  <li>
                    Your cryptocurrency wallet will automatically deduct the Network Fees, that vary depending on
                    network conditions and the desired speed needed for transaction confirmation. Low Network Fees
                    have a higher risk of transaction de-prioritization or transaction failure during network
                    propagation. Cryllex Services will estimate the Network Fees as "Provisional Fees" and apply
                    them to the costs borne by you for the transaction other than when you use your wallet and
                    authorize a transaction.
                  </li>
                  <li>
                    Additional Network Fees are incurred after a transaction is received by the Merchant, while
                    completing the transaction from the Merchant's temporary self-custodized segregated wallet to
                    their designated Agent or designated off-ramp venue.
                  </li>
                  <li>
                    When Network Fees exceed the equivalent of U.S.$0.01, they are included and listed on the
                    Merchant Invoice or in the E-Commerce Checkout Payment Total, as well as in transaction
                    documents and invoices labeled as a "Network Fee".
                  </li>
                  <li>
                    Refunds will also attract Network Fees. Refund Fees are the costs, including Network Fees, that
                    are incurred in refunding payments that have not yet been settled in Fiat Currencies or can be
                    reversed by the Merchant. Refunds are virtual asset transactions and Refund Fees will be incurred
                    for on-chain refunds (merchant wallet to customer wallet) and costs may differ significantly to
                    off-chain refunds that typically involve Fiat Currency.
                  </li>
                  <li>
                    Cryllex charges an Infrastructure Service Fee for providing its Services to Merchants and
                    Customers. This fee is a percentage of the transaction value. Merchants add this Infrastructure
                    Service Fee to the invoice quote in addition to the Network Fee and cost of the goods or services
                    you are purchasing.
                  </li>
                  <li>
                    Cryllex reserves the right to provision for Network Fees and other virtual asset conversion fees on
                    behalf of the Merchant for each transaction to minimize volatility in expected sales proceeds that
                    may occur while the virtual asset transaction is being processed through the network. The Risk
                    Pricing Engine ("RPE") calculation software is a calculation methodology generally based on
                    volatility metrics of the virtual asset including price volatility and Network Fees. The
                    provisioning for volatility is included in the invoice or e-commerce platform price, charged by the
                    Merchant to the customer. This Cryllex Micro-Service is designed to ensure the Merchant
                    receives the full value of their goods or services amid certain volatile conditions. You agree that
                    by using our Services, you do not hold Cryllex liable for price adjustments and/or variations made
                    during your purchase due to the calculation methodology or the service provided to the Merchant
                    to ensure stability in their transaction value. If you disagree with the pricing and costs, you have
                    the choice not to proceed with the transaction prior to accepting the transaction. Cryllex retains
                    the right to keep fee calculations and methods undisclosed.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div id="block_10" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(9.0) Payment Exceptions: Underpayments, Overpayments, Orphan Payments </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                The term "Payment Exceptions", as used in these Paying Customer Terms, refers collectively to
                Underpayments, Overpayments and Orphan Payments, which are each defined below.
              </span>
            </div>
            <strong className="cx--section-title-lg d-block mt-2">(9.1) Underpayments </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Underpayments occur when insufficient funds are sent as payment for an invoice. Underpayments cannot
                fulfill an invoice (in whole or part), and Cryllex will notify you of the Underpayment via email and/or
                SMS message. You can claim a refund of the Underpayment from the invoice or the Underpayment
                notification message and agree to bear the Refund Fees if you make an Underpayment and will not hold
                Cryllex or the Merchant liable for the losses incurred during a refund. If an Underpayment occurs, you
                will need to generate a new invoice by restarting the checkout process. The new invoice will open a new
                Payment Window, and an updated payment amount will be displayed based on any changes to the Cost
                Calculation Engine.
              </span>
            </div>
            <strong className="cx--section-title-lg d-block mt-2">(9.2) Overpayments </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Overpayments occur when additional funds are sent beyond the amount needed to fully pay an invoice.
                With an overpayment, the funds required to pay the invoice will be remitted to the Merchant, and Cryllex
                will notify you via email and/or SMS messaging of the Overpayment amount. You may claim a refund of
                the Overpayment Difference (the amount in excess of the invoice amount) from the invoice or the
                notification message. Refunds of the Overpayment Difference will be subject to Refund Fees. You agree
                to not hold Cryllex or the Merchant liable for the losses incurred during a Refund.
              </span>
            </div>
            <strong className="cx--section-title-lg d-block mt-2">(9.3) Orphan Payments</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Late payments (i.e. payments made after the expiration of a Payment Window), and payments made to a
                Merchant wallet address that is not associated with any known invoice through an active Payment
                Window are called "Orphan Payments". By making an Orphan Payment, you acknowledge that Cryllex or
                the Merchant cannot be held liable for potential losses, despite our best-effort procedures to recover the
                virtual assets missent. You understand that Cryllex cannot automatically associate an Orphan Payment
                with an email address or SMS capable phone number and as such, we are unable to notify you to claim a
                refund. Instead, you will need to contact Cryllex to request support for an Orphan Payment.
              </span>
              <span className='d-block my-3'>
                You will be asked to cooperate and provide the Cryllex Support Team with additional information to
                identify and support the refund of your Orphan Payment. Cryllex Services cannot apply an Orphan
                Payment to a new invoice. If an Orphan Payment occurs, a new invoice will need to be generated and a
                timely payment in a Supported Virtual Asset will need to be executed to fulfill that payment. If you do
                not provide Cryllex Customer Support with the requested additional information, Cryllex may not be able
                to support the refund of the Orphan Payment to you.
              </span>
            </div>
          </div>
          <div id="block_11" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(10.0) Additional Payment Review</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                From time to time, Cryllex Services will be deployed, on behalf of the Merchants and Agents you have
                agreed to transact with, to perform additional reviews of select transactions. Such reviews may be
                required due to a Merchant's usage of Cryllex's Anti-Money Laundering and Sanctions Compliance
                Services. There will also be occasions where the designated Agents of Merchants, that interact directly
                with their banking partners, may require additional data on transactions. Such payment reviews are most
                common with suspicious transactions.
              </span>
              <span className='d-block my-3'>
                Whenever possible, the Merchant will use our Services to provide prompt notice to you if additional
                payment review is required through the email address and/or SMS compatible phone number you provide
                at the Checkout Window.
              </span>
              <span className='d-block my-3'>
                Additional information may be required from you in connection with such a review, and such information
                will be subject to Cryllex's Privacy Policy. You agree to cooperate with requests for such additional
                information and acknowledge the request comes from the Merchant and/or Agent. If you fail to provide
                the required information, you acknowledge that we will be unable to complete your transaction and that
                Cryllex will not be liable for the failure of the transaction.
              </span>
            </div>
          </div>
          <div id="block_12" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(11.0) Wallet Security</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Cryllex includes a Non-Custodial Software Micro-Service for Merchants and their designated Agents;
                Merchants and Agents will have full control over the access and security of their respective wallets used
                to process your Payment, including the capacity to terminate their wallets.
              </span>
              <span className='d-block my-3'>
                Cryllex will never request your cryptocurrency wallet recovery keys, passphrases or security keys, and
                none of these are required to make a payment using the Services. You are solely responsible for
                maintaining the security of your cryptocurrency wallet, including ensuring that the devices on which you
                maintain and/or access your cryptocurrency wallet are free from viruses, malware or other compromising
                code.
              </span>
              <span className='d-block my-3'>
                By using this Service, you acknowledge that Cryllex is not responsible for the non-fulfillment of your
                purchase, however we may use a best-effort basis to support law enforcement for investigation into fraud
                or theft by a Merchant or other external party
              </span>
            </div>
          </div>
          <div id="block_13" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(12.0) Disclaimers</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES ARE
                PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANT ABILITY, FITNESS
                FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL CRYLLEX
                OR ITS AFFILIATES BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF
                OR IN CONNECTION WITH THE PAYMENT SERVICES, REGARDLESS OF WHETHER
                CRYLLEX OR ITS AFFILIATES KNEW OR HAD REASON TO KNOW OF SUCH CLAIM,
                DAMAGES OR LIABILITY.
              </span>
              <span className='d-block my-3'>
                IN NO EVENT WILL CRYLLEX OR ITS AFFILIATES BE LIABLE FOR ANY USE,
                INTERRUPTION, DELAY OR INABILITY TO USE THE PAYMENT SERVICES, OR ANY
                INDIRECT, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES,
                INCLUDING, WITHOUT LIMITATION, LOST REVENUES OR PROFITS, LOSS OF GOODWILL,
                LOSS OR CORRUPTION OF DATA, WHETHER ARISING OUT OF OR IN CONNECTION WITH
                THESE PAYING CUSTOMER TERMS, BREACH OF CONTRACT, TORT (INCLUDING
                NEGLIGENCE) OR OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE
                FORESEEABLE AND WHETHER OR NOT WE WERE ADVISED OF THE POSSIBILITY OF SUCH
                DAMAGES. FOR CUSTOMERS CONTRACTING WITH CRYLLEX, WHILE CRYLLEX
                DISCLAIMS LIABILITY FOR LOST PROFITS AND INDIRECT DAMAGES, CRYLLEX DOES
                NOT OTHERWISE EXCLUDE ITS LIABILITY FOR ITS GROSS NEGLIGENCE OR WILLFUL
                MISCONDUCT.
              </span>
            </div>
          </div>
          <div id="block_14" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(13.0) Limitation of Liability </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU ACCESS AND USE THE CRYLLEX
                SERVICE AT YOUR OWN RISK. IN NO EVENT SHALL WE, OUR RESPECTIVE OFFICERS,
                DIRECTORS, EMPLOYEES BE LIABLE OR RESPONSIBLE TO YOU OR ANY THIRD PARTY
                FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAAL OR EXEMPLARY
                DAMAGES, WHETHER FORESEEABLE OR NOT, UNDER CONTRACT OR TORT, INCLUDING
                DAMAGES FOR LOSS OF PROFITS, LOSS OF BUSINESS, REVENUE, USE, DATA, MONEY,
                GOODWILL, REPUTATION OR OTHER ECONOMIC ADVANTAGE, EVEN IF WE ARE AWARE
                OF OR ADVISED OF THE POSSIBILITY FO THE SAME, ARISING OUT OF OR IN CONNECTION
                WITH OUR WEBSITE OR THE CRYLLEX SERVICE OR THESE TERMS.
              </span>
              <span className='d-block my-3'>
                IF YOU ARE DISSATISFIED WITH ANY PART OR THE WHOLE OF THE CRYLLEX SERVICE,
                BEYOND ANY COMPLIMENTARY EFFORT BY CRYLLEX TO HELP RESOLVE YOUR
                DISSATISFACTION, YOUR SOLE REMEDY IS TO DISCONTINUE USE OF THE CRYLLEX
                SERVICE.
              </span>
              <span className='d-block my-3'>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW AND ONLY TO THE EXTENT THE
                PREVIOUS PARAGRAPH DOES NOT APPLY, IF WE ARE LIABLE FOR ANY LOSS OR
                DAMAGES DESPITE THE PROVISIONS IN THESE TERMS, YOU AGREE THAT NO ACTION,
                WHATEVER ITS FORM, MAY BE BROUGHT BY YOU MORE THAN ONE YEAR AFTER THE
                EVENT WHICH GAVE RISE TO YOUR CLAIM. IN NO EVENT SHALL CRYLLEX'S
                CUMULATIVE LIABILITY TO YOU EXCEED THE LESSER OF (A) THE AMOUNT OF ITS
                PROFITS MADE FROM THE PAYMENT GIVING RISE TO OR ASSOCIATED WITH THE
                APPLICABLE CLAIM, OR (B) FIVE HUNDRED U.S. DOLLARS (US$500).
              </span>
            </div>
          </div>
          <div id="block_15" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg d-block">(14.0) Governing Law, Arbitration and Class Action Waiver</strong>
            <strong className="cx--section-title-lg d-block mt-2">(14.1) Initial Resolution Effort </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                We understand that disputes can arise in the course of transactions. If you, as a Paying Customer, have a
                concern or dispute regarding a transaction, we encourage you to first attempt to resolve the issue directly
                with the Merchant. Most disputes can be resolved at this stage.
              </span>
              <span className='d-block my-3'>
                If you are unable to resolve your dispute with the Merchant, or if your issue is directly with Cryllex
                Services, fill out a Customer Support Ticket via our webpage or contact our Customer Support Team at&nbsp;
                <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com</a>.
              </span>
              <div className='my-3'>
                <span>
                  If you are contacting us via email, please provide:
                </span>
                <ol>
                  <li>Your name and email address;</li>
                  <li>A detailed description of the issue;</li>
                  <li>Any relevant transaction details (e.g., transaction number, date, and amount);</li>
                  <li>What resolution you are seeking.</li>
                </ol>
              </div>
              <span className='d-block my-3'>
                Our Customer Support team will investigate your dispute and aim to resolve it in a timely manner,
                typically within 30 days.
              </span>
            </div>
            <strong className="cx--section-title-lg">(14.2) Mediation</strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Should the issue not be resolved through Customer Support, we offer a mediation process as the next step.
                Mediation will involve a neutral third party to facilitate resolution between you and the other party (either
                the Merchant or Cryllex). This step is voluntary, but it can be a faster, less formal way to resolve disputes
                than arbitration.
              </span>
            </div>
            <strong className="cx--section-title-lg d-block mt-2">(14.3) Governing Law </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Any disputes arising out of or related to these Terms and Conditions of the use of The Services will be
                governed by the laws of British Virgin Island, without regard to its conflict of law principles.
              </span>
            </div>
          </div>
          <div id="block_16" className="cx--contact-info-wrapper mt-4">
            <strong className="cx--section-title-lg">(15.0) Modification to this Agreement </strong>
            <div className="cx--contact-info-text mt-2">
              <span>
                Cryllex reserves the right to update this Agreement at any time and at our sole discretion. If changes are
                made, we will post the amended Agreement to our website. In some instances, upon an update to these
                Terms, Cryllex may notify you via email, push notification and/or website pop-up. By using the Services,
                you accept the then effective Terms. If any provision of these Terms is deemed invalid or unenforceable
                under applicable law, then that provision shall be conformed to law to achieve the original intent to the
                extent possible. If the provision cannot be conformed, it shall be struck from these Terms to the extent
                necessary, and all other provisions shall remain in full force and effect. Any failure to enforce any
                provision of these Terms on any occasion shall not act as a waiver on that or any other occasion of that or
                any other provision. As to their subject matter, these Terms (including any other terms or notices
                incorporated herein by reference) comprise the entire agreement between you and Cryllex.
              </span>
            </div>
          </div>



        </div>
      </div>
    </section >
  )
}
